<template>
    <div class="p-col-12 p-pb-0">
        <Button @click="$router.go(-1)" :label="$t('button.back')" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
    </div>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('upload-doc.upload_doc_header') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('upload-doc.doc_title') }}</label>
                            <InputText :class="`${error.title ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Banner.list.title')" id="title2" v-model="title"></InputText>
                            <div class="text-red">{{ error.title }}</div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                {{ $t('upload-doc.upload') }}
                                <span class="img-info" style="color: #17a2b8">(File type: jpg,png,hwp,docs,pdf,xls )</span>
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">{{ $t('button.select_file') }}</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('button.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <div class="text-red" v-show="render1">지원하지 않는 파일입니다</div>
                            <div class="text-red">{{ error.file }}</div>
                            <img id="frame" src width="100px" height="100px" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center">
                <div>
                    <ConfirmPopup group="popup"></ConfirmPopup>
                    <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="reset"></Button>
                    <Button :label="$t('button.confirm')" icon="pi pi-save" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="confirm($event)"></Button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import validateUploadDoc from '../../validations/doc/uploadDoc';
import CardnewsService from '../../service/API/CardnewsService';
import axios from 'axios';
export default {
    name: 'CreateDocument',
    data() {
        return {
            render1: false,
            title: '',
            userid: localStorage.getItem('dfc_Id'),
            status: 'active',
            file: '',
            fileName: '',
            fileExtension: '',
            formData: new FormData(),
            error: {},
        };
    },
    created() {
        this.cardnewsService = new CardnewsService();
    },

    methods: {
        reset() {
            this.title = '';
            this.fileName = '';
        },
        onFileChange(e) {
            this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            //jpg,png,hwp,docs,pdf,xls
            var allowedExtensions = /(\.jpg|\.png|\.hwp|\.docs|\.pdf|\.xls)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                if (this.file.name.length > 26) {
                    this.fileName=this.file.name.slice(0, 25)+'...';
                }else{
                    this.fileName = this.file.name;
                }
                // this.fileName = this.file.name;
                this.formData.append('file', files[0]);
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        confirm(event) {
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '이대로 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '네',
                rejectLabel: '아니요',
                accept: () => {
                    let vcheckData = {
                        title: this.title,
                        file: this.fileName == '' ? '' : 'something',
                    };
                    this.formData.delete('title');
                    this.formData.delete('userId');
                    this.formData.delete('status');
                    const { isInvalid, error } = validateUploadDoc(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.formData.append('title', this.title);
                        this.formData.append('userId', this.userid);
                        this.formData.append('status', this.status);
                        console.log(this.formData);
                        return axios.post('/dfc-admin/user/documents/upload', this.formData).then(() => {
                            this.$router.push({ name: 'UploadedDoclist' });
                        });
                    }
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다.', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
        addcardnews() {},
    },
};
</script>

<style scoped>
.quill-invalid {
    border: 1px solid red;
}
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}
.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}
.SelectBtn {
    max-width: 100px;
}
.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.ql-editor {
    height: 200px;
}
</style>
